import * as React from "react";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { MovieData } from "../../utils/types/app.types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store.ts";
import { updatePopularMovies } from "../../store/slices/movies.slice.ts";
import { init } from "../../utils/GlobalFunctions/initialize.ts";
import PosterCard from "../../components/PosterCard/index.tsx";

const MoviesPage: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const sessionData = useSelector((state: RootState) => state.session);
  const popularMovies = useSelector(
    (state: RootState) => state.movies.popularMovies,
  );

  useEffect(() => {
    init(
      dispatch,
      sessionData,
      "movie/popular",
      popularMovies,
      updatePopularMovies,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="container page-section">
      <h2 className="page-section-title">Popular Movies</h2>

      <div id="popular-movies" className="movie-grid">
        {Array.isArray(popularMovies) &&
          popularMovies.map((movie: MovieData) => (
            <PosterCard
              key={movie.id}
              linkTo={`/movie-details/${movie.id}`}
              title={movie.title}
              posterPath={movie.poster_path}
              subtitle={`Release: ${movie.release_date}`}
            />
          ))}
      </div>

      {location.pathname === "/movies" && (
        <div className="section-cta">
          <Link to="/genres/movie" className="btn-pill">
            Browse movie genres
          </Link>
        </div>
      )}
    </section>
  );
};

export default MoviesPage;
